export const stringToNumber = (text?: string) => Number.parseInt(text || "");
